export default [
  {
    path: '/businessOptions',
    name: 'businessOptions',
    component: () => import('@/views/businessOptions/BusinessOptionsIndex.vue'),
    meta: {},
    children: [
      {
        path: 'generalSetting',
        name: 'generalSetting',
        component: () => import('@/views/businessOptions/generalSetting/GeneralSetting.vue'),
      },
      {
        path: 'numberFormat',
        name: 'numberFormat',
        component: () => import('@/views/businessOptions/numberFormat/NumberFormat.vue'),
      },
      {
        path: 'reportOptions',
        name: 'reportOptions',
        component: () => import('@/views/businessOptions/reportOptions/ReportOptions.vue'),
      },
      {
        path: 'setting-warning',
        name: 'setting-warning',
        component: () => import('@/views/businessOptions/settingWarning/SettingWarning.vue')
      },
      {
        path: 'signer',
        name: 'signer',
        component: () => import('@/views/businessOptions/SignerOptions.vue'),
      },
      {
        path: 'user-signer',
        name: 'user-signer',
        component: () => import('@/views/businessOptions/UserSignPreference.vue'),
      },
      {
        path: 'fptConnectOption',
        name: 'fptConnectOption',
        component: () => import('@/views/businessOptions/fptConnectOption/FptConnectOption.vue'),
      },
    ],
  },
];
